import axios from "axios";

import Settings from '../settings.json'


export let API = axios.create({
    baseURL: Settings.api_url,
    responseType: 'json',
    headers: { 'Content-Type': 'application/json' }
});

API.interceptors.request.use(function (config) {
    const user = JSON.parse(localStorage.getItem('user')),
        token = user ? user.token : false

    config.headers.Authorization = token ? `Token ${token}` : '';
    return config;
});

export let API_LOGIN = axios.create({
    baseURL: Settings.api_login,
    responseType: 'json',
    headers: { 'Content-Type': 'application/json' }
});

API_LOGIN.interceptors.request.use(function (config) {
    const user = JSON.parse(localStorage.getItem('user')),
        token = user ? user.token : false

    config.headers.Authorization = token ? `Token ${token}` : '';
    return config;
});